import { createApi } from '@reduxjs/toolkit/query/react'

import conf from 'configuration'
import { getTripsAPI } from 'utils/api'
import { TripConfigData } from 'features/settings/tripDetailSettingSlice'
import { BookingData } from './tripSlice'

type TripMode = 'regular' | 'consolidated'

export interface GetTripsParams {
  mode: TripMode
  limit: number
  offset: number
  company_id?: string
  from_time?: string
  to_time?: string
  group_ids?: string
  company_ids?: string
  scope?: string
  usage?: string
  platform?: string
  query?: string
}

export interface GetTripsResponse {
  total: number
  bookings: BookingData[]
  trip_config: TripConfigData
}

export const tripsApi = createApi({
  reducerPath: 'tripsApi',
  baseQuery: async ({ params }: { params: GetTripsParams }) => {
    try {
      const { mode, company_id, ...apiParams } = params
      const { data } = await getTripsAPI(apiParams)
      return { data }
    } catch (axiosError: any) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message
        }
      }
    }
  },
  tagTypes: ['Trips'],
  refetchOnMountOrArgChange: conf.RTK_QUERY_CACHE_TIME_SECONDS,
  endpoints: (builder) => ({
    getTrips: builder.query<GetTripsResponse, GetTripsParams>({
      query: (params) => ({ params }),
      providesTags: (result, error, arg) => {
        const filterHash = JSON.stringify({
          mode: arg.mode,
          company_id: arg.company_id,
          from_time: arg.from_time,
          to_time: arg.to_time,
          group_ids: arg.group_ids,
          company_ids: arg.company_ids,
          scope: arg.scope,
          usage: arg.usage,
          platform: arg.platform,
          query: arg.query
        })
        return [{ type: 'Trips', id: filterHash }]
      }
    })
  })
})

export const { useGetTripsQuery, useLazyGetTripsQuery } = tripsApi
